import { createFileRoute } from '@tanstack/react-router';
import MyOrders from '../../components/client/MyOrders';
import ClientPortal from '../../components/portals/ClientPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockUser } from '../../data/mockData';

export const Route = createFileRoute('/client/orders')({
  component: ClientOrdersRoute,
});

function ClientOrdersRoute() {
  const { user, isManager } = useAuth();
  const content = <MyOrders user={user && !isManager ? user : mockUser} />;
  return <ClientPortal>{content}</ClientPortal>;
}
